module.exports = __webpack_public_path__ + "static/media/thepanel.2206fa65.png";